function MainContent(){
    return (
        <div class='main-content'>Main Content</div>
    );
}

export default MainContent;